import { z } from 'zod';
export const tokenModeSchema = z.enum(['light', 'dark']);
export const tokenUpdateItemSchema = z.object({
    key: z.string().min(1).max(100),
    mode: tokenModeSchema.optional(),
    value: z.string().min(1).max(255),
});
export const tokenBulkUpdateSchema = z.object({
    tokens: z.array(tokenUpdateItemSchema).min(1).max(200),
});
export const tokenResetSchema = z.object({
    mode: tokenModeSchema.optional(),
    keys: z.array(z.string().min(1).max(100)).optional(),
});
export const tokenDefaultsUpdateSchema = z.object({
    tokens: z
        .array(z.object({
        key: z.string().min(1).max(100),
        mode: tokenModeSchema.optional(),
        defaultValue: z.string().min(1).max(255),
    }))
        .min(1)
        .max(200),
});
export const uiSettingsUpdateSchema = z.object({
    autoBuild: z.boolean().optional(),
});
export const componentWriteSchema = z.object({
    path: z.string().min(1).max(500),
    content: z.string().min(1).max(1_000_000),
    startLine: z.number().int().min(1).optional(),
    endLine: z.number().int().min(1).optional(),
});
export const componentReadQuerySchema = z.object({
    path: z.string().min(1).max(500),
});
export const presetCreateSchema = z.object({
    name: z.string().min(1).max(100),
    description: z.string().max(500).optional(),
    fromCurrent: z.boolean().optional(),
    data: z
        .object({
        version: z.literal(1),
        light: z.array(z.object({ key: z.string(), value: z.string() })),
        dark: z.array(z.object({ key: z.string(), value: z.string() })),
    })
        .optional(),
});
export const presetImportSchema = z.object({
    version: z.literal(1),
    light: z.array(z.object({ key: z.string().min(1).max(100), value: z.string().min(1).max(255) })),
    dark: z.array(z.object({ key: z.string().min(1).max(100), value: z.string().min(1).max(255) })),
});
//# sourceMappingURL=uiSystem.schema.js.map